<div class="w-full ticket-timeline">
    <div *ngIf="events.length > 0">
        <p-timeline [value]="events" [style]="{'margin-bottom': '10px'}">
            <ng-template #marker let-event>
                <span class="flex w-8 h-8 items-center justify-center rounded-full z-10 shadow-sm timeline-marker"
                      [ngClass]="getMarkerClass(event.type)">
                    {{ getInitials(event.name) }}
                </span>
            </ng-template>
            <ng-template #content let-event>
                <div class="timeline-content group relative">
                    <div class="flex justify-between items-center mb-2">
                        <div class="text-[15px] font-semibold">{{ event.name }}</div>

                        <!-- Hide date & badge on hover -->
                        <div class="flex gap-3 items-center transition-opacity group-hover:opacity-0">
                            <!-- <span class="timeline-type-badge" [ngClass]="getTypeBadgeClass(event.type)">
                                {{ getTypeLabel(event.type) }}
                            </span> -->
                            <div class="text-[11px] text-gray-600">{{ event.date }}</div>
                        </div>

                        <!-- Show icons on hover - only for comments -->
                        <div *ngIf="event.type === 'comment'" class="absolute top-0 right-0 flex gap-2 opacity-0 group-hover:opacity-100 transition-opacity">
                            <button pButton icon="pi pi-pencil"
                                    class="p-button-rounded p-button-text p-button-primary p-button-sm"
                                    (click)="onEditEvent(event)"
                                    title="Edit Comment">
                            </button>
                            <button pButton icon="pi pi-trash"
                                    class="p-button-rounded p-button-text p-button-danger p-button-sm"
                                    (click)="onDeleteEvent(event)"
                                    title="Delete Comment">
                            </button>
                        </div>
                    </div>

                    <div class="text-[13px] mt-1 mb-2 break-words">
                        {{ event.desc }}
                    </div>

                    <div class="text-[13px] mt-1 mb-2" *ngIf="event.type === 'attachment'">
                        <a [href]="event.attachmentUrl" target="_blank" class="attachment-link">
                            <i class="pi pi-paperclip mr-1"></i>{{ event.attachmentName }}
                        </a>
                    </div>
                </div>
            </ng-template>
        </p-timeline>
    </div>

    <div class="flex justify-center mt-5" *ngIf="events.length == 0">
        <div class="text-[15px] font-semibold text-gray-500">No Activity Available</div>
    </div>
</div>
